import { IconSet } from '../IconSet';

/**
 * Our icons require the FFX prefix to avoid collisions with the Fluent UI Icons.
 *
 * The values here must match the unicode value of the character in the font.
 * You can get this value from https://iconcloud.design
 */
const icons = {
  FFXInfo: '\uE946',
  FFXMore: '\uE712',
  FFXPeopleAdd: '\uEA15',
  FFXUneditable: '\uED1D',
  FFXFabricFolder: '\uF0A9',
  FFXAdd: '\uE710',
  FFXAddIn: '\uF775',
  FFXError: '\uE783',
  FFXErrorBadge: '\uEA39',
  FFXChevronLeft: '\uE76B',
  FFXChevronRight: '\uE76C',
  FFXGroup: '\uE902',
  FFXCopyLink: '\uE8C8'
};

export const ffxHostUxIcons: IconSet = {
  fontFamily: 'ffx-host-ux',
  fontExtension: 'woff',

  // Must be manually updated whenever there is a change of the font file.
  sha: '277744dd41',
  icons
};

/**
 * Type containing the icon names of this icon set.
 */
export type FFXHostUxIconsType = keyof typeof icons;
